export default __webpack_public_path__ + "static/psoriazal-8d525d85ed5a2141828cda9cd1513dc4.jpg";